import React from "react";
import { Hearts, Rings } from "react-loader-spinner";
import { useLoading } from "../contexts/LoadingContext";
import "./loader.css";

const Loader = () => {
  const { isLoading } = useLoading();

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader-blur" />

          <Rings
            visible={true}
            height="180"
            width="180"
            color="#8cc63e"
            ariaLabel="rings-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />

          {/* <Hearts
            height="180"
            width="180"
            color="#8cc63e"
            ariaLabel="hearts-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          /> */}
        </div>
      )}
    </>
  );
};

export default Loader;
